<script>
	import { getContext, onDestroy } from 'svelte'
	import { slide } from 'svelte/transition'
	import { setCookie, getCookie } from '../library/scripts/cookie'
	import { styles } from '../library/scripts/styles'
	import {
		storeBuilderPreview,
		storeShowTools,
		storeElementID,
		storeSelectedTool,
		storeUpdate,
		storeShowFinishedBlocks,
		storeData,
		storeContact,
		storeShowFoods,
		storeShowDrinks,
		storeShowRooms,
		storeShop,
		storeShowGallery,
		storeSiteManagement,
		storeHM,
		modalLogin,
		storeSiteAdmin,
	} from '../library/scripts/Store.svelte'
	import { admin as conf } from '../library/scripts/PhpHandler.svelte'
	import Login from '../modals/Login.svelte'
	import Shader from '../library/ShadersAndSpinners/Shader.svelte'
	const globals = getContext('globals')
	const fsS = globals.fsS
	const bg = globals.bgLight
	const icon = globals.icon
	const innerW = globals.devWidth
	const builderToolbar = globals.builderToolbar
	const builderToolbarHover = globals.builderToolbarHover
	let elementID

	let hasMailManagement = false

	let linkColor
	let linkHover
	let ttBG
	let ttFC
	let fontWeight
	let backgroundColor

	//for the responsive navbar
	let visibleMenu = false
	let menuPosition = null
	let navHeight = 'clamp(25px, 3vw, 40px)'

	$: if (innerW < 650) {
		menuPosition = 'flex-end'
	}

	// social media
	let socialMedia = []

	//timeouts
	let TO

	// admin
	let adminCookie = getCookie('id')
	if (adminCookie.length == 0) {
		storeSiteAdmin.set(false)
		storeBuilderPreview.set(true)
	}

	if (adminCookie.length > 30) {
		storeSiteAdmin.set(true)
	}

	let configFile
	let HSC
	let HFC
	let HPOP

	const stoData = storeData.subscribe((value) => {
		if (value) {
			value.blocks.forEach((block) => {
				if (block.blockName === 'navbar') {
					linkColor = block.fontColor
					linkHover = block.fontHover
					backgroundColor = block.backgroundColor
					ttBG = block.ttBG
					ttFC = block.ttFC
					fontWeight = block.fontWeight
					menuPosition = block.align
					HSC = block.HSC
					HFC = block.HFC
					HPOP = block.HPOP
				}
			})

			if (value.widgets.indexOf('mail-management') > -1) hasMailManagement = true
			if (value.social) socialMedia = value.social
			configFile = value
		} else {
			configFile = conf({ cmd: 'get_config_file', id: 'loadSite' })
			configFile.then((value) => {
				storeData.set(value)
			})
		}
	})

	let showTools
	let navWidth = '100vw'
	const stoShowTools = storeShowTools.subscribe((value) => {
		showTools = value
	})

	$: if (showTools) navWidth = '82vw'
	$: if (!showTools) navWidth = '100vw'

	const set_elementID = (e) => {
		storeShowTools.set(true)
		elementID = e
		storeElementID.set(e)
	}

	const admin_log_in = () => {
		modalLogin.set(true)
		if (innerW < 650) visibleMenu = false
	}

	const log_out = () => {
		const builderWidth = document.getElementById('builderBlock')
		const toolWidth = document.querySelector('#tools')
		storeSiteAdmin.set(false)
		storeShowTools.set(false)
		storeBuilderPreview.set(true)
		setCookie('id', '', -20)
		setTimeout(() => {
			if (builderWidth) {
				builderWidth.style.width = '100vw'
				toolWidth.style.width = '0vw'
				visibleMenu = visibleMenu = false
			}
			storeSiteManagement.set(false)
		}, 1)
	}

	const open_link = (l) => {
		// storeShowRooms.set(false)
		// close open tools if user jumps to admin without closing the tool window
		const builderWidth = document.getElementById('builderBlock')
		const toolWidth = document.querySelector('#tools')
		if (l === 'administrator') {
			storeContact.set(false)
			setTimeout(() => {
				if (builderWidth) {
					builderWidth.style.width = '100vw'
					toolWidth.style.width = '0vw'
				}
				storeSiteManagement.set(true)
			}, 1)
		}
	}

	const show_preview = () => {
		close_tools()
		storeBuilderPreview.set(true)
		visibleMenu = false
	}

	const close_preview = () => {
		storeBuilderPreview.set(false)
		visibleMenu = false
	}

	const close_builder = (e) => {
		storeUpdate.set(false)
		storeShowFinishedBlocks.set(true)
		storeContact.set(false)
		storeShowGallery.set(false)
		storeShowFoods.set(false)
		storeShowDrinks.set(false)
		storeShowRooms.set(false)
		storeShop.set(false)
		storeShowTools.set(false)
		storeElementID.set('--')
		storeSelectedTool.set('--')
		document.getElementById('tools').style.width = '0vw'
		document.getElementById('builderBlock').style.width = '100vw'
		visibleMenu = false
		TO = setTimeout(() => {
			sessionStorage.clear()

			document.location = '/#/createblock'
			document.getElementsByTagName('body')[0].style.backgroundColor = bg
			document.getElementById('builderBlock').remove()
		}, 500)
	}

	const close_tools = () => {
		storeShowTools.set(false)
		document.getElementById('tools').style.width = '0vw'
		const bB = document.getElementById('builderBlock')
		if (bB) {
			document.getElementById('builderBlock').style.width = '100vw'
		}

		document.getElementById('navbar').style.width = '100vw'
	}

	const open_hamburger = () => {
		visibleMenu = visibleMenu === true ? false : true
	}

	const open_social = (s) => {
		socialMedia.forEach((soc) => {
			if (soc.name === s) window.open(soc.link)
		})
	}

	onDestroy(() => {
		stoShowTools
		stoData
		clearTimeout(TO)
	})
</script>

{#if !$storeBuilderPreview && $storeSiteAdmin}
	<div
		class="content_row"
		use:styles={{ fsS, builderToolbar, builderToolbarHover }}
		on:click={() => set_elementID('Navbar')}
		on:keydown={() => set_elementID('Navbar')}
	>
		<div style="margin-left:20px;">*OPEN NAVBAR TOOL*</div>
	</div>
{/if}
{#if configFile.blocks}
	{#each configFile.blocks as block}
		{#if block.blockName === 'navbar'}
			<div
				id="navbar"
				style="
			display: flex;
			position:{block.position};
			justify-content: {menuPosition};
			align-items: {block.valign};
			margin-top:{block.marginTop}%;
			margin-bottom:{block.marginBottom}%;
			padding-top: {block.paddingTop}%;
			padding-right: {block.paddingRight}%;
			padding-bottom: {block.paddingBottom}%;
			padding-left: {block.paddingLeft}%;
			height: {navHeight};
			width: {navWidth};
			background-color: {block.backgroundColor};
			border-bottom: {block.borderBottomWidth}px {block.borderBottomStyle} {block.borderBottomColor};
			border-top: {block.borderTopWidth}px {block.borderTopStyle} {block.borderTopColor};
			box-shadow: 0px {block.shadowOffsetY}px {block.shadowBlur}px {block.shadowColor};
			z-index:1;
			"
			>
				{#if socialMedia.length > 0}
					<div class="social_outer">
						{#each socialMedia as soc}
							{#if soc.name === 'facebook'}
								<div
									class="social_icon fb_img"
									data-tooltip="follow on facebook"
									use:styles={{ fsS, ttBG, ttFC }}
									on:click={() => open_social('facebook')}
									on:keydown={() => open_social('facebook')}
								/>
							{/if}

							{#if soc.name === 'linkedin'}
								<div
									class="social_icon linkedin_img"
									data-tooltip="follow on linkedIn"
									use:styles={{ fsS, ttBG, ttFC }}
									on:click={() => open_social('linkedin')}
									on:keydown={() => open_social('linkedin')}
								/>
							{/if}

							{#if soc.name === 'instagram'}
								<div
									class="social_icon instagram_img"
									data-tooltip="follow on instagram"
									use:styles={{ fsS, ttBG, ttFC }}
									on:click={() => open_social('instagram')}
									on:keydown={() => open_social('instagram')}
								/>
							{/if}

							{#if soc.name === 'telegram'}
								<div
									class="social_icon telegram_img"
									data-tooltip="follow on telegram"
									use:styles={{ fsS, ttBG, ttFC }}
									on:click={() => open_social('telegram')}
									on:keydown={() => open_social('telegram')}
								/>
							{/if}

							{#if soc.name === 'twitter'}
								<div
									class="social_icon twitter_img"
									data-tooltip="follow on X"
									use:styles={{ fsS, ttBG, ttFC }}
									on:click={() => open_social('twitter')}
									on:keydown={() => open_social('twitter')}
								/>
							{/if}

							{#if soc.name === 'youtube'}
								<div
									class="social_icon youtube_img"
									data-tooltip="follow on youtube"
									use:styles={{ fsS, ttBG, ttFC }}
									on:click={() => open_social('youtube')}
									on:keydown={() => open_social('youtube')}
								/>
							{/if}
						{/each}
					</div>
				{/if}
				{#if innerW > 650}
					{#if $storeSiteAdmin}
						<div
							class="nav_bar_link"
							use:styles={{ fsS, fontWeight, linkColor, linkHover }}
							on:click={() => open_link('administrator')}
							on:keydown={() => open_link('administrator')}
						>
							administrator
						</div>

						{#if $storeBuilderPreview}
							<div
								class="nav_bar_link"
								use:styles={{ fsS, fontWeight, linkColor, linkHover }}
								on:click={close_preview}
								on:keydown={close_preview}
							>
								open builder
							</div>
						{:else}
							<div
								class="nav_bar_link"
								use:styles={{ fsS, fontWeight, linkColor, linkHover }}
								on:click={show_preview}
								on:keydown={show_preview}
							>
								close builder
							</div>
						{/if}

						<div
							class="nav_bar_link"
							use:styles={{ fsS, fontWeight, linkColor, linkHover }}
							on:click={close_builder}
							on:keydown={close_builder}
						>
							manage content
						</div>

						<div
							class="nav_bar_link"
							use:styles={{ fsS, fontWeight, linkColor, linkHover }}
							on:click={log_out}
							on:keydown={log_out}
						>
							logout
						</div>

						{#if $storeHM}
							<div class="nav_bar_link" style="margin-right:50px;">
								<div
									class="hamburger_container"
									use:styles={{ icon }}
									on:click={open_hamburger}
									on:keydown={open_hamburger}
								>
									<div class="hamburger_icon" use:styles={{ icon, HSC }} />
								</div>
								{#if visibleMenu}
									<div
										transition:slide={{ duration: 1000 }}
										class="hamburger_menu"
										use:styles={{ fsS, navHeight, HPOP, navWidth, backgroundColor }}
									>
										{#if $storeSiteAdmin}
											<div
												class="nav_bar_link hamburger_link"
												use:styles={{ fsS, fontWeight, HFC }}
												on:click={() => open_link('administrator')}
												on:keydown={() => open_link('administrator')}
											>
												administrator
											</div>
											{#if $storeBuilderPreview}
												<div
													class="nav_bar_link hamburger_link"
													use:styles={{ fsS, fontWeight, HFC }}
													on:click={close_preview}
													on:keydown={close_preview}
												>
													open builder
												</div>
											{:else}
												<div
													class="nav_bar_link hamburger_link"
													use:styles={{ fsS, fontWeight, HFC }}
													on:click={show_preview}
													on:keydown={show_preview}
												>
													close builder
												</div>
											{/if}

											<div
												class="nav_bar_link hamburger_link"
												use:styles={{ fsS, fontWeight, HFC }}
												on:click={close_builder}
												on:keydown={close_builder}
											>
												manage content
											</div>
										{/if}
									</div>
								{/if}
							</div>
						{/if}
					{:else}
						<div
							class="nav_bar_link"
							use:styles={{ fsS, fontWeight, linkColor, linkHover }}
							on:click={admin_log_in}
							on:keydown={admin_log_in}
						>
							login
						</div>
					{/if}
				{:else if innerW < 650}
					<div class="hamburger_container" use:styles={{ icon }} on:click={open_hamburger} on:keydown={open_hamburger}>
						<div class="hamburger_icon" use:styles={{ icon, HSC }} />
					</div>
					{#if visibleMenu}
						<div
							transition:slide={{ duration: 1000 }}
							class="hamburger_menu"
							use:styles={{ fsS, navHeight, HPOP, navWidth, backgroundColor }}
						>
							{#if $storeSiteAdmin}
								<div
									class="nav_bar_link hamburger_link"
									use:styles={{ fsS, fontWeight, HFC }}
									on:click={() => open_link('administrator')}
									on:keydown={() => open_link('administrator')}
								>
									administrator
								</div>
								{#if $storeBuilderPreview}
									<div
										class="nav_bar_link hamburger_link"
										use:styles={{ fsS, fontWeight, HFC }}
										on:click={close_preview}
										on:keydown={close_preview}
									>
										open builder
									</div>
								{:else}
									<div
										class="nav_bar_link hamburger_link"
										use:styles={{ fsS, fontWeight, HFC }}
										on:click={show_preview}
										on:keydown={show_preview}
									>
										close builder
									</div>
								{/if}

								<div
									class="nav_bar_link hamburger_link"
									use:styles={{ fsS, fontWeight, HFC }}
									on:click={close_builder}
									on:keydown={close_builder}
								>
									manage content
								</div>

								<div
									class="nav_bar_link hamburger_link"
									use:styles={{ fsS, fontWeight, HFC }}
									on:click={log_out}
									on:keydown={log_out}
								>
									logout
								</div>
							{:else}
								<div
									class="nav_bar_link hamburger_link"
									use:styles={{ fsS, fontWeight, HFC }}
									on:click={admin_log_in}
									on:keydown={admin_log_in}
								>
									login
								</div>
							{/if}
						</div>
					{/if}
				{/if}
			</div>
		{/if}
	{/each}
{/if}

{#if $modalLogin}
	<Shader>
		<div slot="content">
			<Login />
		</div>
	</Shader>
{/if}

<style>
	.nav_bar_link {
		color: var(--linkColor);
		font-size: var(--fsS);
		font-weight: var(--fontWeight);
		cursor: pointer;
		padding: 20px;
	}

	.nav_bar_link:hover {
		color: var(--linkHover);
	}

	.hamburger_container {
		display: block;
		position: absolute;
		top: 0px;
		width: var(--icon);
		height: var(--icon);
		margin-top: 5px;
		margin-right: 15px;
		cursor: pointer;
	}

	.hamburger_icon,
	.hamburger_icon::before,
	.hamburger_icon::after {
		display: block;
		position: absolute;
		background-color: var(--HSC);
		width: 25px;
		height: 3px;
		border-radius: 10px;
	}

	.hamburger_icon {
		top: 5px;
	}

	.hamburger_icon::before {
		content: '';
		margin-top: -6px;
	}

	.hamburger_icon::after {
		content: '';
		margin-top: 6px;
	}

	.hamburger_menu {
		position: absolute;
		left: 58%;
		top: var(--navHeight);
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		height: fit-content;
		width: 40%;
		padding: 1vw 3vw 0 0;
		background: var(--HPOP);
		font-size: var(--fsS);
		border-left: 1px solid var(--backgroundColor);
		border-right: 1px solid var(--backgroundColor);
		border-bottom: 1px solid var(--backgroundColor);
		box-shadow: 3px 3px 3px black;
	}

	.hamburger_link {
		color: var(--HFC);
	}

	.content_row {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
	}

	.social_outer {
		display: flex;
		width: 50%;
		height: 100%;
		justify-content: flex-start;
		align-items: center;
	}

	.social_icon {
		display: block;
		width: clamp(15px, 1.6vw, 25px);
		height: clamp(15px, 1.6vw, 25px);
		background-size: cover;
		cursor: pointer;
		margin-right: 20px;
	}

	.fb_img {
		background-image: url('../images/facebook.svg');
	}

	.youtube_img {
		background-image: url('../images/youtube.svg');
	}

	.linkedin_img {
		background-image: url('../images/linkedin.svg');
	}

	.instagram_img {
		background-image: url('../images/instagram.svg');
	}

	.twitter_img {
		background-image: url('../images/twitter.svg');
	}

	.telegram_img {
		background-image: url('../images/telegram.svg');
	}

	[data-tooltip]:hover::before {
		content: '';
		display: inline-block;
		position: relative;
		left: clamp(-8px, -0.8vw, -14px);
		border-left: clamp(15px, 1.6vw, 25px) solid transparent;
		border-right: clamp(15px, 1.6vw, 25px) solid transparent;
		border-bottom: clamp(15px, 1.6vw, 25px) solid var(--ttBG);
		border-top: clamp(15px, 1.6vw, 25px) solid transparent;
		animation: fade_in_animation 0.5s;
		animation-timing-function: ease-in-out;
	}

	[data-tooltip]:hover::after {
		content: attr(data-tooltip);
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		color: var(--ttFC);
		font-size: var(--fsS);
		width: clamp(100px, 19vw, 300px);
		height: clamp(30px, 3.1vw, 50px);
		left: 50%;
		transform: translateX(-50%);
		top: -10px;
		background-color: var(--ttBG);
		border-radius: 10px;
		animation: fade_in_animation 0.5s;
		animation-timing-function: ease-in-out;
	}

	.content_row {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		width: 100%;
		cursor: pointer;
		font-style: italic;
		font-size: var(--fsS);
		background-color: var(--builderToolbar);
		height: 40px;
		border-bottom: 1px solid hsl(0, 0%, 50%);
	}

	.content_row:hover {
		background-color: var(--builderToolbarHover);
	}

	@keyframes fade_in_animation {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}
</style>
